// Floating hint card pinned next to a highlighted page element, showing the tour snippet's text
// right where the user is looking — same visual technique as the topbar tour hint, but purely
// transient (no log, no never-show-again). One card at a time; the tour driver shows it while a
// step's element is highlighted, the drawer while a clicked snippet's element pulses.

let card: HTMLElement | null = null;
let target: Element | null = null;
let detach: (() => void) | null = null;

function position(): void {
  if (!card || !target) return;
  const r = target.getBoundingClientRect();
  const cw = card.offsetWidth;
  const ch = card.offsetHeight;
  const left = Math.min(Math.max(8, r.left), Math.max(8, window.innerWidth - cw - 8));
  // Below the element; above when there is no room underneath.
  let top = r.bottom + 8;
  if (top + ch > window.innerHeight - 8) top = Math.max(8, r.top - ch - 8);
  card.style.left = `${left}px`;
  card.style.top = `${top}px`;
}

export function showAnchorHint(el: Element, text: string, color?: string): void {
  clearAnchorHint();
  card = document.createElement("div");
  card.className = "assistant-anchor-hint";
  if (color) card.style.borderColor = color;
  card.textContent = text.replace(/\*\*/g, ""); // the snippet's markdown bold → plain card text
  target = el;
  document.body.appendChild(card);
  position();
  // The smooth scrollIntoView (and any user scroll / resize) moves the target — follow it.
  const repos = () => position();
  window.addEventListener("scroll", repos, true);
  window.addEventListener("resize", repos);
  detach = () => {
    window.removeEventListener("scroll", repos, true);
    window.removeEventListener("resize", repos);
  };
}

export function clearAnchorHint(): void {
  detach?.();
  detach = null;
  card?.remove();
  card = null;
  target = null;
}
